// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___BarB","content":"styles_content__PFbcS","title":"styles_title__TFE6_","bonus":"styles_bonus__yCUKH","buttonWrapper":"styles_buttonWrapper__va21W"};